import { useTranslation } from 'react-i18next';
import Button from '@/components/ui/Button';
import type { BulkCreateResult } from './types';
import { exportErrorsToExcel } from './exportErrors';
import styles from './SharedStyles.module.css';

interface ResultsTableProps {
  result: BulkCreateResult;
  exportFileName: string;
}

export default function ResultsTable({ result, exportFileName }: ResultsTableProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.resultsContainer}>
      <div className={styles.resultsSummary}>
        <div className={styles.summaryItem}>
          <span className={`${styles.summaryLabel} body-sm-regular`}>{t('bulkUploads.totalRows')}</span>
          <span className={styles.summaryValue}>{result.totalRows}</span>
        </div>
        <div className={`${styles.summaryItem} ${styles.successItem}`}>
          <span className={`${styles.summaryLabel} body-sm-regular`}>{t('bulkUploads.successCount')}</span>
          <span className={styles.summaryValue}>{result.successCount}</span>
        </div>
        <div className={`${styles.summaryItem} ${styles.failureItem}`}>
          <span className={`${styles.summaryLabel} body-sm-regular`}>{t('bulkUploads.failureCount')}</span>
          <span className={styles.summaryValue}>{result.failureCount}</span>
        </div>
      </div>

      {result.failureCount > 0 && (
        <Button
          variant="outline"
          onClick={() => exportErrorsToExcel(result.results, exportFileName)}
        >
          {t('bulkUploads.exportErrors')}
        </Button>
      )}

      <div className={styles.resultsTableWrapper}>
        <table className={styles.resultsTable}>
          <thead>
            <tr>
              <th className="body-sm-semibold">{t('bulkUploads.rowNumber')}</th>
              <th className="body-sm-semibold">{t('bulkUploads.israeliId')}</th>
              <th className="body-sm-semibold">{t('bulkUploads.status')}</th>
              <th className="body-sm-semibold">{t('bulkUploads.errorDetail')}</th>
            </tr>
          </thead>
          <tbody>
            {result.results.map((row) => (
              <tr key={row.rowNumber} className={row.success ? styles.successRow : styles.errorRow}>
                <td className="body-sm-regular">{row.rowNumber}</td>
                <td className="body-sm-regular">{row.israeliId}</td>
                <td>
                  <span className={`body-xs-sm-regular ${row.success ? styles.successBadge : styles.errorBadge}`}>
                    {row.success ? t('bulkUploads.success') : t('bulkUploads.failure')}
                  </span>
                </td>
                <td className="body-sm-regular">{row.errorMessage ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
